import React from "react";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import FormSelect from "../forms/FormSelect";
import Services from "../../services/Services";
import { SupportTicketCategoryType } from "../../services/ISupportTicketCategoryRepository";
import ISupportTicketCategory from "../../models/ISupportTicketCategory";
import { selectAuth } from "../../store/auth/selectors";
import firstOrDefault from "../../functions/firstOrDefault";
import snackbarService from "../../services/ui-messaging/SnackbarService";

export interface ISupportTicketCategorySelectProps {
  token: string;
  type: SupportTicketCategoryType;
  category?: ISupportTicketCategory;
  readonly?: boolean;
  className?: string;
  onMenuPathChange: (val: ISupportTicketCategory | undefined) => void;
}

const SupportTicketCategorySelect = (props: ISupportTicketCategorySelectProps) => {
  const { token, type, category, readonly, onMenuPathChange, className } = props;
  const [items, setItems] = React.useState<ISupportTicketCategory[]>([]);

  React.useEffect(() => {
    const getCats = async () => {
      if (token) {
        try {
          const repo = await new Services().SupportTicketCategoryRepository();
          const cats = await repo.get(token, type);
          setItems(cats);
        } catch (err) {
          snackbarService.error(`Failed to retrieve categories: ${err}`);
        }
      }
      return [];
    };
    getCats();
  }, [token, category]);

  let item: ISupportTicketCategory | null | undefined = null;
  if (items && category) {
    item = firstOrDefault(items, i => i.MenuPath === category.MenuPath);
  }

  const label = type === SupportTicketCategoryType.ServiceRequest ? "Request" : "Category";

  const prompt = type === SupportTicketCategoryType.ServiceRequest ? "Select a Service Request" : "Select a Category";

  return (
    <FormSelect<ISupportTicketCategory>
      className={className}
      name="SupportTicketCategory.ID"
      label={label}
      prompt={prompt}
      options={items}
      option={item}
      readonly={readonly}
      required
      onValueChange={val => onMenuPathChange(val || undefined)}
    />
  );
};

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(SupportTicketCategorySelect);
